<cc-filters-layer></cc-filters-layer>
<cc-filters-search></cc-filters-search>
<cc-filter-universal></cc-filter-universal>
<cc-filter-call-length></cc-filter-call-length>
<cc-filter-phone-number></cc-filter-phone-number>
<cc-row-tags-editor-wrapper></cc-row-tags-editor-wrapper>
<cc-top-bar [title]="'CONTACTS_LIST.TITLE' | translate">
  <a href="#" class="no-hover show-always">
  </a>
  <cc-top-bar-item class="search-phrase-field">
    <div class="filter-body-item search-phrase-field-wrapper">
      <i class="material-icons">search</i>
      <input #phraseSearch
             [placeholder]="'SEARCH' | translate"
             [(ngModel)]="phrase"
             (input)="setPhrase(phraseSearch.value)"
             (keyup.enter)="searchByPhrase()"
             (keyup)="clearFilterWhenEmpty(phraseSearch.value)"
             class="item-search-input"/>
    </div>
  </cc-top-bar-item>
</cc-top-bar>
<div class="app-wrapper contacts">
  <div class="contacts-top-panel">
    <button (click)="toggleTable()" class="toggle-table-option" [class.events]="isEventsTable">
      <span class="toggle-table-option-left" translate>CONTACTS_LIST.CONTACTS</span>
      <span class="toggle-table-option-right" translate>CONTACTS_LIST.HISTORY</span>
    </button>
    <ng-container *ngxPermissionsOnly="'EXPORT_CONTACTS_PERMISSION'">
      <button class="export-button contacts-top-panel-btn"
              *ngIf="!isEventsTable"
              [disabled]="!hasDataToExport"
              (click)="getContactsReport()">
        <i class="fas fa-sign-out-alt"></i>
        <span class="contacts-top-panel-btn-label" translate="CONTACTS_LIST.EXPORT"></span>
      </button>
    </ng-container>
  </div>
  <cc-events-table *ngIf="isEventsTable"></cc-events-table>
  <cc-contacts-table *ngIf="!isEventsTable"></cc-contacts-table>
</div>
<cc-date-picker
  *ngIf="datepickerVisible"
  (selected)="changeDateRange($event)"
  [maxDate]="maxDate"
  [minDate]="minDate"
  [startDate]="startDate"
  [endDate]="endDate"
  [opens]="opens"
  class="date-range-input h-100-p">
</cc-date-picker>
